import { INFOSERVICES } from '../actions/infoServices';

const defaultState = {
  terms: { content: '', isLoaded: false },
  info: { content: '', isLoaded: false },
  faq: { content: '', isLoaded: false },
  contact: { content: 'Coming soon...', isLoaded: true },
};

export default (state = defaultState, { type, page, ...action }) => {
  switch (type) {
    case INFOSERVICES.LOAD_DONE:
      return {
        ...state,
        [page]: { ...state[page], content: action.text, isLoaded: true },
      };

    case INFOSERVICES.LOAD_FAILED:
      return { ...state, [page]: { ...state[page], isLoaded: true } };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/infoServices.js